import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DUMMY_NATIVE_BRIDGE, NativeBridgeStoreProvider, useNativeBridgeActions, useNativeBridgeSelector, } from '#pplx/frontend/apps/ask/native-bridges/store.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import React, { useEffect } from 'react';
function AuthStatusUpdater() {
    const { status } = useSession();
    const nativeBridgeActions = useNativeBridgeActions();
    useEffect(() => {
        nativeBridgeActions.setAuthStatus(status);
    }, [nativeBridgeActions, status]);
    return null;
}
function BridgeComponent() {
    const Bridge = useNativeBridgeSelector((state) => state.BridgeComponent);
    const nativeBridgeActions = useNativeBridgeActions();
    return _jsx(Bridge, { actions: nativeBridgeActions });
}
// Provider component that wraps the app with the appropriate native bridge implementation
// Should be called at app initialization with the result from resolveNativeBridge()
export function NativeBridgeRegistryProvider({ children, stateCreator = DUMMY_NATIVE_BRIDGE, shouldRenderBridgeComponent = true, }) {
    return (_jsxs(NativeBridgeStoreProvider, { initialValue: stateCreator, children: [_jsx(AuthStatusUpdater, {}), shouldRenderBridgeComponent && _jsx(BridgeComponent, {}), children] }));
}
//# sourceMappingURL=NativeBridgeRegistryProvider.js.map